/**
 * Development environment
 */
export enum Environment {
  LOCAL = "local",
  DEV = "dev",
  PROD = "prod",
}
